import { baseRequest } from '.'
import _get from 'lodash/get'

export const getApiKey = async () => {
  const res = await baseRequest.get(`/webhook/api_key`)
  return _get(res, 'data')
}

export const generateApiKey = async () => {
  const res = await baseRequest.post(`/webhook/api_key`)
  return _get(res, 'data')
}
